import { Box, Grid, Icon } from '@mui/material'
import React from 'react';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import DetailData from './DetailData';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import Form from './Form';
import { Link } from 'react-router-dom';
import { useTheme } from '@emotion/react';

function Details() {
    let theme=useTheme();
    let details=[
        {dataName:"Address",data:"Gachibowli, Hyderabad, Telangana",href:`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent("Gachiboli, Hyderabad, Telangana")}`,icon:LocationOnIcon},
        {dataName:"Email",data:"kadapasharief 786@gmail.com",href:"mailto:kadapasharief786@gmail.com",icon:EmailIcon},
        {dataName:"Phone",data:"7989738066",href:"tel:7989738066",icon:LocalPhoneIcon},
        { dataName: "Linkedin", data: "Kadapa Sharief", href:"https://www.linkedin.com/in/sharief-k-89a046169/",icon:LinkedInIcon}
    ]
  return (
    
    <>
        <Box>
            <Grid container>
                <Grid container xs={12} sm={12} md={6} rowSpacing={5}>
                {
                    details.map((obj)=>
                    {
                        return(
                            <Grid item xs={12} sm={6} md={12}  
                                sx={{
                                    display:"flex",
                                    flexDirection:"row",
                                    alignItems:"center",
                                    gap:"7%"
                                }}
                                key={obj}
                                data-aos="fade-up" data-aos-duration="2000"
                            >
                                
                                <Box 
                                    component="a"
                                    href={obj.href}
                                    target='__blank'
                                    sx={{
                                        color:"text.primary",
                                        // backgroundColor:obj.bgColor,
                                        border:"1px solid white",
                                        borderRadius:"100%",
                                        display:"flex",
                                        justifyContent:"center",
                                        alignItems:"center",
                                        padding:"20px",
                                        boxShadow:`
                                        3px 3px 5px ${theme.palette.primary.main},
                                        -3px 3px 5px ${theme.palette.secondary.main},
                                        3px -3px 5px ${theme.palette.tertiary.main}
                                        `,  
                                        transition:"all 0.3s ease-out",
                                        '&:hover':{
                                            boxShadow:`
                                            3px 3px 10px green ,
                                            -3px 3px 10px red ,
                                            3px -3px 10px violet ,
                                            0px 0px 10px white inset
                                        `,
                                        transform:"scale(1.1)",
                                        
                                        },
                                
                                        


                                        
                                    }}
                                >
                                    <Icon component={obj.icon}/>
                                </Box>

                                <DetailData dataName={obj.dataName} data={obj.data}/>
                            </Grid>
                        )
                    })
                }
                </Grid>
                
                <Grid item xs={12} sm={12} md={6} sx={{mt:{xs:5,sm:5,md:0}}}>
                   <Form/>
                </Grid>
            </Grid>
        </Box>
    </>
  )
}

export default Details